// src/pages/PrivacyPage.tsx
import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
      
      <div className="prose lg:prose-lg">
        <p>
          Last updated: March 18, 2025
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">1. Introduction</h2>
        <p className="mb-4">
          This Privacy Policy explains how LoadDrive ("we", "us", or "our") collects, uses, and discloses your
          information when you use our service.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">2. Information We Collect</h2>
        <p className="mb-4">
          We collect information you provide directly to us when you register for an account, create or modify
          your profile, set preferences, or upload documents.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">3. How We Use Your Information</h2>
        <p className="mb-4">
          We use the information we collect to provide, maintain, and improve our services, to process and
          complete transactions, and to send you related information including confirmations, technical notices,
          updates, security alerts, and support and administrative messages.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">4. Sharing Your Information</h2>
        <p className="mb-4">
          We do not share your personal information with third parties without your consent, except in the following circumstances:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>With vendors, consultants, and other service providers who need access to such information to carry out work on our behalf</li>
          <li>In response to a request for information if we believe disclosure is in accordance with any applicable law, regulation, or legal process</li>
          <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property, and safety of us or others</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">5. Data Security</h2>
        <p className="mb-4">
          We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">6. Your Rights</h2>
        <p className="mb-4">
          You may update, correct, or delete your account information at any time by logging into your account. If you wish to delete your account, please contact us at privacy@LoadDrive.com.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">7. Changes to This Privacy Policy</h2>
        <p className="mb-4">
          We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy and, in some cases, we may provide you with additional notice.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">8. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at privacy@LoadDrive.com.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
